// SNIGJ - Security Shield Component
// Protects against source code inspection and developer tools

import { useEffect } from 'react';

const SecurityShield = ({ children }) => {
  useEffect(() => {
    // Check if we're on mobile - don't apply aggressive protections on mobile
    const isMobile = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    // Disable right-click context menu (desktop only)
    const handleContextMenu = (e) => {
      if (!isMobile) {
        e.preventDefault();
        return false;
      }
    };

    // Disable keyboard shortcuts for dev tools (desktop only)
    const handleKeyDown = (e) => {
      if (isMobile) return; // Skip on mobile
      
      // F12
      if (e.keyCode === 123) {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+I (Dev Tools)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 73) {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+J (Console)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 74) {
        e.preventDefault();
        return false;
      }
      // Ctrl+Shift+C (Element selector)
      if (e.ctrlKey && e.shiftKey && e.keyCode === 67) {
        e.preventDefault();
        return false;
      }
      // Ctrl+U (View source)
      if (e.ctrlKey && e.keyCode === 85) {
        e.preventDefault();
        return false;
      }
      // Ctrl+S (Save page)
      if (e.ctrlKey && e.keyCode === 83) {
        e.preventDefault();
        return false;
      }
    };

    // Console warning message (safe for all devices)
    const consoleWarning = () => {
      console.clear();
      console.log(
        '%c⛔ ARRÊTEZ !',
        'color: red; font-size: 50px; font-weight: bold;'
      );
      console.log(
        '%cCeci est une application gouvernementale protégée.',
        'color: #eab308; font-size: 18px;'
      );
      console.log(
        '%cL\'accès non autorisé au code source est une violation de la loi.',
        'color: white; font-size: 14px;'
      );
      console.log(
        '%cMinistère de la Justice - RDC',
        'color: #94a3b8; font-size: 12px;'
      );
    };

    // Inject fake source code comment (safe for all devices)
    const injectFakeSource = () => {
      const fakeComment = document.createComment(`
    ╔══════════════════════════════════════════════════════════════╗
    ║                                                              ║
    ║     SYSTÈME NATIONAL INTÉGRÉ DE GESTION DE LA JUSTICE       ║
    ║              République Démocratique du Congo                ║
    ║                                                              ║
    ║     Ce code source est protégé par le droit d'auteur.       ║
    ║     Toute tentative de copie, modification ou distribution   ║
    ║     non autorisée est strictement interdite et punissable   ║
    ║     par la loi.                                              ║
    ║                                                              ║
    ║     Ministère de la Justice et Garde des Sceaux              ║
    ║     Direction des Systèmes d'Information Judiciaire          ║
    ║                                                              ║
    ║     Version: 8.0.0                                           ║
    ║     Build: PROD-2026-SECURE                                  ║
    ║                                                              ║
    ╚══════════════════════════════════════════════════════════════╝

    AVERTISSEMENT LÉGAL:
    ---------------------
    En accédant à ce système, vous acceptez d'être soumis à la
    surveillance de vos activités. Toute tentative d'accès non
    autorisé, de modification ou de destruction des données est
    passible de poursuites judiciaires conformément aux articles
    215-220 du Code Pénal de la RDC.

    Contact sécurité: security@justice.gouv.cd
    `);
      document.head.insertBefore(fakeComment, document.head.firstChild);
    };

    // Add event listeners (only on desktop)
    if (!isMobile) {
      document.addEventListener('contextmenu', handleContextMenu);
      document.addEventListener('keydown', handleKeyDown);
    }
    
    // Run safe protections on all devices
    consoleWarning();
    injectFakeSource();

    // Cleanup
    return () => {
      if (!isMobile) {
        document.removeEventListener('contextmenu', handleContextMenu);
        document.removeEventListener('keydown', handleKeyDown);
      }
    };
  }, []);

  return children;
};

export default SecurityShield;
